/**
 * React dependencies
 */
import { createRoot } from 'react-dom/client';

/**
 * DWT dependencies
 */
import FeaturedBookComponent from './FeaturedBook';

/**
 * Render Featured Book
 *
 * Initializes Featured Book components on the front-end
 */
const renderFeaturedBook = () => {
  const featuredBookContainers = document.querySelectorAll( '.featured-book-container' );

  featuredBookContainers.forEach( ( container ) => {
    // Avoid re-rendering if already initialized
    if ( container._reactRootContainer ) return;

    try {
      const bookData = JSON.parse( container.getAttribute( 'data-featured-book' ) );

      // Create React root and render Featured Book
      const root = createRoot( container );

      root.render(
        <FeaturedBookComponent bookData={bookData} />
      );

      // Mark as initialized
      container._reactRootContainer = root;
    } catch ( error ) {
      console.error( 'Error initializing featured book:', error );
    }
  });
};

export default renderFeaturedBook;
